// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"482":"06726e9846cbbf22efc5","655":"3713a847c547e323f95f"}[chunkId] + ".js");